import React, { useEffect, useState } from 'react'
import './FestivalWinnerGift.css'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import FestivalWinnerGiftComponent from '../../Components/FestivalWinnerGiftComponent/FestivalWinnerGiftComponent'
import { Apiurl, GetLocalStorageParsed, parseData } from '../utils/page'
import axios from 'axios'

const FestivalWinnerGift = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [winnerData, setWinnerData] = useState();
  const [winnerWithPorduct, setWinnerWithProduct] = useState();

  // Get Vendors
  const GetWinner = () => {
    // setLoading("winner")
    const option = {
      method: "GET",
      headers: {
        accept: '*/*',
        'Authorization': `Bearer ${loginToken ? loginToken : ""}`
      },
      url: `${Apiurl()}/api/SpecialOffer/GetWinningProducts`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result)
        const sortedData = data?.sort((a, b) => a.Position - b.Position);

        setWinnerData(sortedData)
      })
      .catch((error) => {
        console.error(error);
      });
  };
  // Get Vendors
  const GetClaimeProducts = () => {

    // setLoading("winner")
    const option = {
      method: "GET",
      headers: {
        accept: '*/*',
        'Authorization': `Bearer ${loginToken ? loginToken : ""}`
      },
      url: `${Apiurl()}/api/SpecialOffer/GetClaimedProducts`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result)
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // get all product
  const GetWinnerWithProduct = () => {
    const data = {
      "Id": null
    }
    const options = {
      method: "POST",
      headers: {
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${loginToken || " "}`
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/SpecialOffer/GetWinnersWithProduct`
    };
    axios(options)
      .then((e) => {
        const parsedData = parseData(e?.data?.result);
        const sortedData = parsedData?.sort((a, b) => a.Position - b.Position);
        setWinnerWithProduct(sortedData)
      })
      .catch((error) => {
      });
  }
  
  useEffect(() => {
    GetWinner();
    GetWinnerWithProduct();
    GetClaimeProducts();
  }, []);

  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

        <Header setLoginToken={setLoginToken}
        />
        <FestivalWinnerGiftComponent winnerData={winnerData} winnerWithPorduct={winnerWithPorduct}/>
        <Footer />
      </div>
    </>
  )
}

export default FestivalWinnerGift
